import React, { useState } from 'react';
import { usePos } from '../context/PosContext';
import './About.css';

// About / Subscription / Privacy / Terms (content_abouts_layout.xml,
// subscription_layout.xml, privacy_policy_layout.xml, tc_layout.xml).
// Combined into one tabbed screen. App version mirrors the Android build.
const APP_VERSION = '3.5.36 (web)';
const COMPANY = 'Eposdigital solution.';
const WEBSITE = 'www.eposdigital.com';
const SUPPORT = 'info.eposdigitalsolutions@gmail.com';

type Tab = 'about' | 'subscription' | 'privacy' | 'terms';

const TABS: { key: Tab; label: string }[] = [
  { key: 'about', label: 'About' },
  { key: 'subscription', label: 'Subscription' },
  { key: 'privacy', label: 'Privacy Policy' },
  { key: 'terms', label: 'Terms & Conditions' },
];

const About: React.FC = () => {
  const { config } = usePos();
  const [tab, setTab] = useState<Tab>('about');

  return (
    <div className="about-page">
      <div className="page-header">
        <h1>ABOUT</h1>
      </div>

      <div className="about-tabs">
        {TABS.map((t) => (
          <button key={t.key} className={tab === t.key ? 'active' : ''} onClick={() => setTab(t.key)}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'about' && (
        <div className="about-card">
          <div className="about-hero">
            <div className="about-logo">EP</div>
            <div>
              <h2>{config.storeName}</h2>
              <p className="muted">EPOS · v{APP_VERSION}</p>
            </div>
          </div>
          <div className="about-info">
            <div><span>Outlet</span><strong>{config.storeName}</strong></div>
            {config.address && <div><span>Address</span><strong>{config.address}</strong></div>}
            {config.phone && <div><span>Phone</span><strong>{config.phone}</strong></div>}
            {config.gstin && <div><span>GSTIN</span><strong>{config.gstin}</strong></div>}
            <div><span>Version</span><strong>{APP_VERSION}</strong></div>
          </div>
          <div className="about-brand">
            <strong>{COMPANY}</strong>
            <a href={`https://${WEBSITE}`} target="_blank" rel="noreferrer">{WEBSITE}</a>
            <a href={`mailto:${SUPPORT}`}>{SUPPORT}</a>
          </div>
        </div>
      )}

      {tab === 'subscription' && (
        <div className="about-card">
          <h2>Subscription Plans</h2>
          <p>
            asnasoftware POS is intended for retail billing and is powered by cloud services. We offer
            continuous improvements plus the asnasoftware Biz app for real-time reporting of your business
            transactions, under an annual maintenance subscription.
          </p>
          <div className="about-plan">
            <div>
              <div className="plan-name">Annual Maintenance</div>
              <div className="muted">Billing, reports & cloud sync · 1 year</div>
            </div>
            <div className="plan-price">₹ 18,000<span>/yr</span></div>
          </div>
          <p className="muted">Pay with any UPI app to <strong>eposdigital@upi</strong>, or contact {SUPPORT}.</p>
          <button className="about-pay" onClick={() => alert('Online payment requires the backend — contact ' + SUPPORT)}>
            Pay Now
          </button>
        </div>
      )}

      {tab === 'privacy' && (
        <div className="about-card about-legal">
          <h2>Privacy Policy</h2>
          <p>
            {config.storeName} uses EPOS to process sales and manage business data. All POS
            data (products, customers, sales, settings) in this web app is stored locally in your
            browser; it is not transmitted to any server by the application.
          </p>
          <h3>Information we store</h3>
          <p>Product, customer, supplier and sales records you enter, kept on this device for billing and reporting.</p>
          <h3>How it is used</h3>
          <p>Solely to operate the point-of-sale: producing bills, reports and inventory tracking. We do not sell or share your data.</p>
          <h3>Your control</h3>
          <p>You can export or clear all data at any time from Settings → Data Management.</p>
          <p className="muted">For questions contact {SUPPORT}.</p>
        </div>
      )}

      {tab === 'terms' && (
        <div className="about-card about-legal">
          <h2>Terms &amp; Conditions</h2>
          <p>By using EPOS you agree to the following terms.</p>
          <h3>Use of the application</h3>
          <p>The application is provided for lawful retail and restaurant billing. You are responsible for the accuracy of the data you enter and for any tax or regulatory compliance.</p>
          <h3>Data &amp; backups</h3>
          <p>Data is stored locally in your browser. You are responsible for taking regular backups (Settings → Export Data). Clearing browser storage will remove your data.</p>
          <h3>Liability</h3>
          <p>The application is provided “as is” without warranty. {COMPANY} is not liable for losses arising from use, data loss, or business interruption.</p>
          <h3>Subscription</h3>
          <p>Continued cloud services and support are subject to an active annual subscription.</p>
          <p className="muted">For questions contact {SUPPORT}.</p>
        </div>
      )}
    </div>
  );
};

export default About;
